export default __webpack_public_path__ + "static/media/030-eel.60390fa3.svg";